import { useQuery } from '@tanstack/react-query';

import { api } from 'src/lib/api-client';

const getServiceHealth = () => api.get('/api/v1/announcements/service-health/');

const getServiceHealthQueryOptions = () => ({
  queryKey: ['service-health'],
  queryFn: getServiceHealth,
});

export const useServiceHealthQuery = ({ queryConfig } = {}) =>
  useQuery({
    ...getServiceHealthQueryOptions(),
    ...queryConfig,
  });
